const config = { domain: 'Account', subdomain: 'User' }

interface Signed_Up {
  userId: number
  nonprofitOrgId: number
  role: string
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Signed_In {}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface NavigationItemClicked {}

export const user = {
  Signed_Up: { Signed_Up: (param: Signed_Up) => param, config },
  Signed_In: { Signed_In: (param: Signed_In) => param, config },
  Signed_Out: { Signed_Out: (param: Signed_In) => param, config },
  Clicked: {
    Clicked: (param: NavigationItemClicked) => param,
    config,
  },
}
